const SELECTORS = {
    miniCart: '.js--mini-cart',
    cartIcon: '.js--cart-icon',
    close: '.js--mini-cart-close',
    remove: '.js--mini-cart-remove',
    cartForm: 'form.cart',
};
const INIT_ATTR = 'data-mini-cart-init';
const OPEN_CLASS = 'mini-cart-open';
const WC_AJAX_URL = '/?wc-ajax=add_to_cart';
const getMiniCart = () => document.querySelector(SELECTORS.miniCart);
const isOpen = (el) => el.getAttribute('aria-hidden') === 'false';
const show = (el) => {
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add(OPEN_CLASS);
};
const hide = (el) => {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('hidden', '');
    document.body.classList.remove(OPEN_CLASS);
};
const applyFragments = (fragments) => {
    Object.entries(fragments).forEach(([selector, html]) => {
        document.querySelectorAll(selector).forEach(el => {
            el.outerHTML = html;
        });
    });
};
const removeCartItem = async (cartKey, itemEl) => {
    const { ajax_url, nonce } = window.var_from_php ?? {};
    if (!ajax_url || !nonce)
        return;
    itemEl.classList.add('is-removing');
    const body = new FormData();
    body.append('action', 'wp_rock_remove_cart_item');
    body.append('nonce', nonce);
    body.append('cart_key', cartKey);
    try {
        const res = await fetch(ajax_url, { method: 'POST', body });
        const json = await res.json();
        if (!json.success) {
            itemEl.classList.remove('is-removing');
            return;
        }
        applyFragments(json.data.fragments);
        const updated = getMiniCart();
        if (updated)
            show(updated);
    }
    catch {
        itemEl.classList.remove('is-removing');
    }
};
const initAddToCart = () => {
    const form = document.querySelector(SELECTORS.cartForm);
    if (!form || form.hasAttribute(INIT_ATTR))
        return;
    form.setAttribute(INIT_ATTR, '');
    const btn = form.querySelector('.single_add_to_cart_button, [name="add-to-cart"]');
    if (!btn)
        return;
    btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const productId = (btn.value ||
            form.querySelector('[name="product_id"]')?.value ||
            '');
        if (!productId)
            return;
        const quantity = form.querySelector('[name="quantity"]')?.value ?? '1';
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('loading');
        try {
            const body = new FormData();
            body.append('product_id', productId);
            body.append('quantity', quantity);
            const res = await fetch(WC_AJAX_URL, { method: 'POST', body });
            const json = await res.json();
            if (!json.error && json.fragments) {
                applyFragments(json.fragments);
                const updated = getMiniCart();
                if (updated)
                    show(updated);
            }
        }
        finally {
            btn.removeAttribute('disabled');
            btn.classList.remove('loading');
        }
    });
};
const applyMiniCartFragments = (fragments) => {
    [SELECTORS.miniCart, '.js--cart-dot-wrapper'].forEach(key => {
        const html = fragments[key];
        if (!html)
            return;
        document.querySelectorAll(key).forEach(el => {
            el.outerHTML = html;
        });
    });
};
const syncFromServer = () => {
    const wasOpen = getMiniCart()?.getAttribute('aria-hidden') === 'false';
    return fetch('/?wc-ajax=get_refreshed_fragments')
        .then(r => r.json())
        .then(({ fragments }) => {
        if (!fragments)
            return;
        applyMiniCartFragments(fragments);
        if (wasOpen) {
            const mc = getMiniCart();
            if (mc)
                show(mc);
        }
    })
        .catch(() => undefined);
};
const initWcEventsSync = () => {
    const $jq = window.jQuery;
    if (typeof $jq !== 'function')
        return;
    $jq(document.body).on('removed_from_cart updated_cart_totals wc_cart_emptied', () => void syncFromServer());
};
export const initMiniCart = () => {
    const miniCart = getMiniCart();
    if (!miniCart)
        return;
    const cartIcon = document.querySelector(SELECTORS.cartIcon);
    cartIcon?.addEventListener('click', (e) => {
        e.preventDefault();
        const mc = getMiniCart();
        if (!mc)
            return;
        isOpen(mc) ? hide(mc) : show(mc);
    });
    document.addEventListener('click', (e) => {
        const target = e.target;
        if (target.closest(SELECTORS.close)) {
            const mc = getMiniCart();
            if (mc)
                hide(mc);
        }
    });
    document.addEventListener('click', (e) => {
        const target = e.target;
        const mc = getMiniCart();
        if (!mc || !isOpen(mc))
            return;
        if (!target.closest(SELECTORS.miniCart) && !target.closest(SELECTORS.cartIcon)) {
            hide(mc);
        }
    });
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape')
            return;
        const mc = getMiniCart();
        if (mc && isOpen(mc)) {
            hide(mc);
            document.querySelector(SELECTORS.cartIcon)?.focus();
        }
    });
    document.addEventListener('click', async (e) => {
        const target = e.target;
        const btn = target.closest(SELECTORS.remove);
        if (!btn)
            return;
        const cartKey = btn.dataset.cartKey;
        const itemEl = btn.closest('.mini-cart__item');
        if (cartKey && itemEl)
            await removeCartItem(cartKey, itemEl);
    });
    initAddToCart();
    initWcEventsSync();
};
export default initMiniCart;
